export default {"src":"/_next/static/media/goal-wellness.a7420951.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};